import { ref } from 'vue'
import { AxiosInstance } from 'axios'
import { getFollowers } from '/@src/api/userRepo'
import { PageRequestParam, UserListResponse } from '/@src/models/api'

export default function useUserFollowers(
  api: AxiosInstance,
  param: PageRequestParam
) {
  const response = ref<UserListResponse>()
  const getUserFollowers = async () => {
    const ret = await getFollowers(api, param.id!!, param.limit, param.cursor)
    response.value = ret
  }
  return {
    response,
    getUserFollowers,
  }
}
